import {IPersistenceStore} from "./ipersistence.store";
import {Injectable} from "@angular/core";

@Injectable()
export class SessionStoragePersistenceStore implements IPersistenceStore {

    getForKey(success:Function, failure:Function, key:string, service:string, accessGroup:string) {
        var value = window.sessionStorage.getItem(key);
        success(value);
    };

    getKeySynchronously(key:string) {
        return window.sessionStorage.getItem(key);
    };

    setForKey(success:Function, failure:Function, key:string, service:string, accessGroup:string, value:string) {
        window.sessionStorage.setItem(key, value);
        success();
    };

    setKeySynchronously(key:string, value:string) {
        window.sessionStorage.setItem(key, value);
    };

    removeForKey(success:Function, failure:Function, key:string, service:string, accessGroup:string) {
        window.sessionStorage.removeItem(key);
        success();
    };

}